import { get } from 'lodash-es';

export const selectConfigureRatesModel = (state) => get(state, 'configureRatesModel');
export const selectIsModalOpenStatus = (state) => get(state, 'isModalOpen');
